import React from "react";

// constants
import { BsPlus } from "react-icons/bs";

type ITextMultipleInput = {
  container?: string;
  onChange: (data: string) => void;
  label?: string;
};

const TextMultipleInput: React.FC<ITextMultipleInput> = ({
  container,
  onChange,
  label,
}) => {
  const [data, dataSet] = React.useState<string>("");

  return (
    <div>
      {label && (
        <div className="text-md tracking-wider mb-2 font-semibold">{label}</div>
      )}
      <div
        className={`w-full flex border rounded-lg overflow-hidden px-2 py-1 ${container}`}
      >
        <input
          type="text"
          // name="multi_text"
          value={data}
          className="outline-none flex-1"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            dataSet(e.target.value)
          }
        />
        <div
          className="flex items-center bg-primary-500 hover:bg-primary-800 px-2 py-[0.125rem] rounded-md text-white font-medium cursor-pointer"
          onClick={() => {
            if (data) {
              dataSet("");
              onChange(data);
            }
          }}
        >
          <BsPlus size={20} />
          <span className="tracking-wider">Add</span>
        </div>
      </div>
    </div>
  );
};

export default TextMultipleInput;
